import { downloadURL } from "./DownloadUtil";

export function generateReport(reportName, downloadName, reportFilters) {
	let url = "report/" + reportName;
	const fetchOptions = { body: JSON.stringify(reportFilters), method: "POST" };
	downloadURL(url, downloadName, "Report generated.  Look for it in your download area.",
		"Report generation failed.", fetchOptions);
}